export const en = {
    'add-placements': {
        one: 'Add a billboard format: {formats} to expand audience coverage',
        some: 'Add billboard formats: {formats} to expand audience coverage',
        many: 'Add billboard formats: {formats} to expand audience coverage',
        none: ''
    },
    title: 'Add billboards in suitable formats',
    'title-hint': 'This recommendation appears as there are no billboards suitable for the creatives selected',
    'video-format': '{width}x{height}, {duration}sec.'
};
